import { Component,  EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { UploadRrmsServiceLiveDataComponent } from '../upload-rrms-service-live-data/upload-rrms-service-live-data.component';

@Component({
  selector: 'app-rrms-service-live-dashboard',
  templateUrl: './rrms-service-live-dashboard.component.html',
  styleUrls: ['./rrms-service-live-dashboard.component.scss']
})
export class RrmsServiceLiveDashboardComponent implements OnInit {

  rrmsServiceLiveForm: FormGroup;
  countryData: any;
  showTable: boolean; 
  allnodeValue:any;
  tableData:any;

  constructor(private spinnerService: Ng4LoadingSpinnerService,
    private formBuilder: FormBuilder, private router: Router,
    private endpointsService: EndpointsService, private dialog: MatDialog,
    private backendApiService: BackendApiService) { }

  ngOnInit(): void {
    this.createRrmsSderviceLiveForm();
    this.getApiDataLoad();
   
  }
  createRrmsSderviceLiveForm() {
    this.rrmsServiceLiveForm = this.formBuilder.group({
      hpmnCountry: [''],
      nodetype: [''],
    
    });
  }
  
   getApiDataLoad() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService. URL_GET_RRMS_SERVICE_LIVE_DATA  ; 
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.countryData = response;
    });
   
  }
  getNodeType(){
    this.spinnerService.show();
    this.backendApiService.callToApi(
      this.endpointsService.URL_GET_RRMS_SERVICE_LIVE_DATA + '&country=' + this.rrmsServiceLiveForm.get('hpmnCountry').value).subscribe(response => {

        console.log("ssss",response)
        setTimeout(()=>{
          response.filter((item)=>{
            this.allnodeValue=item.type;
        },1000)
     
      })
      console.log("responseeee",this.allnodeValue)
    });
    this.onSearch();

  }
  onSearch(){
    this.spinnerService.show()
    let country = this.rrmsServiceLiveForm.get('hpmnCountry').value
    // this.showTable=true;
    console.log("aaza",this.rrmsServiceLiveForm.get('hpmnCountry').value)
    let apiUrl;
    if(country === null || country === '' || country === undefined){
     apiUrl = this.endpointsService.URL_GET_RRMS_SERVICE_LIVE_DATA;
    }else{
      apiUrl = this.endpointsService.URL_GET_RRMS_SERVICE_LIVE_DATA + '&country=' + country;
    }

  console.log('apiUrl: ' + apiUrl);
  this.backendApiService.callToApi(apiUrl).subscribe(response => {
    // this.spinnerService.hide();
    if (response === null ) {
      return;
    }
    
    this.tableData = response;
    console.log("this.table",this.tableData)
    this.showTable = true;
    this.spinnerService.hide()
  })
  }
  onReset(){
    this.spinnerService.show();
    this.showTable = false;
    this.createRrmsSderviceLiveForm();
  }
  addService(){
    this.router.navigate(['service-live-dashboard/add-rrms-service-live'])
  }
  onFileUploadClick(){
    const dialogRef = this.dialog.open(UploadRrmsServiceLiveDataComponent, {
      width: '1000px',
   //   data: {rowData: item},
      panelClass: 'custom-modalbox',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed : ' + result);
    });
  }
}
